export default "__VITE_ASSET__a51beb1f__"